import styled from "styled-components"
import Images from "../../config/images"

export const DownloadAppStyle = styled.div`
  padding: 10px 16px;
  background-color: ${(props) => props.theme.bgcolordarkblue};
  background-image: url(${Images.flashbanner});
  background-size: cover;
  background-position: top center;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  display: none;
  @media only screen and (max-width: 767px) {
    display: flex;
  }
`
export const Title = styled.h6`
  color: ${(props) => props.theme.textcolordwhite3};
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  @media only screen and (max-width: 420px) {
    max-width: 170px;
  }
`
